import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import { Login, Register, ForgotPassword, ResetPassword } from "@/pages/Auth";
import Account from "@/pages/Account";
import { About, Contact, Journey, Lookbook } from "@/pages/StaticPages";
import AdminApp from "@/pages/Admin";
import { BlogList, BlogPost } from "@/pages/Blog";

/** Every time the page (route) changes, start at the top of the new page. */
function ScrollToTop() {
  const { pathname } = useLocation();
  React.useLayoutEffect(() => {
    try { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); } catch { window.scrollTo(0, 0); }
  }, [pathname]);
  return null;
}

function AppShell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/*" element={<AdminApp/>}/>
      </Routes>
    );
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/shop" element={<Shop/>}/>
        <Route path="/shop/:slug" element={<Shop/>}/>
        <Route path="/product/:slug" element={<ProductDetail/>}/>
        <Route path="/cart" element={<Cart/>}/>
        <Route path="/checkout" element={<Checkout/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/register" element={<Register/>}/>
        <Route path="/forgot-password" element={<ForgotPassword/>}/>
        <Route path="/reset-password" element={<ResetPassword/>}/>
        <Route path="/account/*" element={<Account/>}/>
        {/* the Bespoke / custom request page was removed — old links go to the contact page */}
        <Route path="/customize" element={<Navigate to="/contact" replace/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/journey" element={<Journey/>}/>
        <Route path="/blog" element={<BlogList/>}/>
        <Route path="/blog/:slug" element={<BlogPost/>}/>
        <Route path="/lookbook" element={<Lookbook/>}/>
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop/>
        <AppShell/>
      </BrowserRouter>
      <Toaster position="top-center" richColors/>
    </AuthProvider>
  );
}
